import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { reduxForm, change } from 'redux-form';
import Button from 'react-bootstrap/lib/Button';
import cx from 'classnames';

import PlaceGeoSuggest from '../../Common/GeoSuggest/PlaceGeoSuggest';

import { setPersonalizedValues } from '../../../actions/personalized';
import detectMobileBrowsers from '../../../helpers/detectMobileBrowsers';
import { searchFormSuggestSelect, changeSearchForm } from '../../../helpers/GeoSuggest/updateSearchForm';
import messages from '../../../locale/jsonMessages';
import history from '../../../core/history';

import streeingIcon from '/public/SiteIcons/streeingFormIcon.svg';
import { SearchSvgIcon } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon';

import cs from '../../../components/commonStyle.css';
import s from './LocationSearchForm.css';

const LocationSearchForm = (props) => {
  const {
    intl: { formatMessage },
    setPersonalizedValues,
    change,
    personalized,
    listingFields,
  } = props;

  const [mobileDevice, setMobileDevice] = useState(false);
  const [personCapacity, setPersonCapacity] = useState([]);

  useEffect(() => {
    if (detectMobileBrowsers.isMobile()) {
      setMobileDevice(true);
    }
    if (listingFields) {
      setPersonCapacity(listingFields.personCapacity);
    }
  }, []);

  useEffect(() => {
    if (listingFields) {
      setPersonCapacity(listingFields.personCapacity);
    }
  }, [listingFields]);

  const onSuggestSelect = (data, value) => {
    searchFormSuggestSelect({ data, setPersonalizedValues, value });
  };

  const onChangeSearch = (value) => {
    if (value === '') {
      changeSearchForm({ setPersonalizedValues, change });
    }
  };

  const handleClick = () => {
    let uri = '/s?';
    if (personalized?.chosen != null) {
      uri += `&address=${personalized.location}&chosen=${personalized.chosen}`;
    } else if (personalized?.location != null) {
      uri += `&address=${personalized.location}`;
    }
    const updatedURI = encodeURI(uri);
    history.push(updatedURI);
  };

  return (
    <div className={cx(s.locationGrid, 'homeLocationSearchForm')}>
      <div className={s.locationFlex}>
        <div className={s.iconWidth}>
          <img src={streeingIcon} />
        </div>
        <PlaceGeoSuggest
          initialValue={personalized?.location}
          placeholder={formatMessage(messages.homeWhere)}
          onSuggestSelect={onSuggestSelect}
          onChange={onChangeSearch}
          id="locationSearch"
          containerClassName="layoutOneLocationSearchGeoSuggest widthFull"
        />
      </div>
      <div className={s.btnWidth}>
        <Button
          className={cx(cs.btnPrimary, s.btnBlock, s.btnLarge)}
          onClick={handleClick}
        >
          <SearchSvgIcon
            className={cx('imgIconRight', 'imgIconRightMb')}
          />
          <span className="hidden-xs">
            <FormattedMessage {...messages.search} />
          </span>
        </Button>
      </div>
    </div>
  );
};

LocationSearchForm.propTypes = {
  setPersonalizedValues: PropTypes.any.isRequired,
  getSpecificSettings: PropTypes.any,
  personalized: PropTypes.shape({
    location: PropTypes.string,
    lat: PropTypes.number,
    lng: PropTypes.number,
    chosen: PropTypes.number,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    personCapacity: PropTypes.number,
  }),
  settingsData: PropTypes.shape({
    listSettings: PropTypes.array.isRequired,
  }).isRequired,
};

LocationSearchForm.defaultProps = {
  personalized: {
    location: null,
    lat: null,
    lng: null,
    startDate: null,
    endDate: null,
    personCapacity: null,
    chosen: null,
  },
  settingsData: {
    listSettings: [],
  },
};

const mapState = (state) => ({
  personalized: state?.personalized,
  settingsData: state?.viewListing?.settingsData,
  listingFields: state?.listingFields?.data,
  location: state?.personalized?.location,
});

const mapDispatch = {
  setPersonalizedValues,
  change,
};

export default injectIntl(
  withStyles(cs, s)(
    connect(mapState, mapDispatch)(
      reduxForm({
        form: 'SearchForm',
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
      })(LocationSearchForm)
    )
  )
);
